var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cagura-wrapper"},[_c('div',{staticClass:"movie-container"},[_c('div',{staticClass:"video-modal"},[_c('video',{attrs:{"controls":"","id":"cagura-movie-video"}}),_c('button',{staticClass:"btn-success",on:{"click":function($event){return _vm.closePlayer()}}},[_vm._v("CLOSE")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }